import React from 'react';
import { Bell, PhoneIncoming, Power, UserPlus } from 'lucide-react';
import { ALERT_TOGGLES, toggleText } from '../../lib/alertToggles.js';

const ICONS = { masterSwitch: Power, smsAlerts: Bell, callAlerts: PhoneIncoming, leadAlerts: UserPlus };

/**
 * The four Ringy-style alert buttons: solid green when ON, dark/muted when OFF.
 * @param {{state: Record<string, boolean>, onToggle: (key: string, next: boolean) => void, disabled?: boolean}} props
 * @returns {JSX.Element}
 */
export default function AlertToggleButtons({ state, onToggle, disabled = false }) {
  return (
    <div className="space-y-1.5" data-testid="alert-toggles">
      {ALERT_TOGGLES.map(({ key, label, hint }) => {
        const on = !!state[key];
        const Icon = ICONS[key];
        return (
          <button
            key={key}
            type="button"
            role="switch"
            aria-checked={on}
            title={hint}
            disabled={disabled}
            data-testid={`alert-${key}`}
            onClick={() => onToggle(key, !on)}
            className={`w-full flex items-center gap-4 px-4 py-3 rounded-md text-sm font-bold tracking-wide transition cursor-pointer disabled:opacity-60 ${
              on
                ? 'bg-emerald-600 text-white hover:bg-emerald-500'
                : 'bg-red-500 text-white hover:bg-red-400'
            }`}
          >
            <Icon className="w-5 h-5 shrink-0" />
            <span>{toggleText(label, on)}</span>
          </button>
        );
      })}
    </div>
  );
}
